<div [ngClass]="tenantClass$ | async">
  <div class="inventory-item-shell">
    <div class="inventory-item-shell__header">
      <section class="header">
        <div class="container">
          @if (isMobile) {
            <div class="back-link mb-3 mb-sm-0">
              @if (backLink$ | async; as backLink) {
                <a [routerLink]="backLink.targetUri" class="d-inline-flex back-link-mobile"
                  data-track-elem="button" [attr.data-track-name]="backLink.text" allytmln="Back">
                  <i class="allycon-glyph-chevron-left" aria-hidden="true"></i>
                  <span>{{translations.backLinkMobile}}</span>
                </a>
              }
            </div>
          }
          <h1 id="main-content-focus" class="jumbotron-heading mb-2 mt-2 mt-md-0 mb-md-3" tabindex="-1">
            <strong>{{ header.text }}</strong>
          </h1>
        </div>
      </section>
      <div class="inventory-item-shell_container">
        <section class="container">
          @if (auctionItem$ | async; as auctionItem) {
            <nav id="inventory-item-navigation"
              class="inventory-item-shell_card px-2 px-md-3 py-3 border border-dark wrapper d-sm-flex align-items-center justify-content-between"
              >
              @if (!isMobile) {
                <div class="back-link mb-3 mb-sm-0">
                  @if (backLink$ | async; as backLink) {
                    <a [routerLink]="backLink.targetUri" class="d-inline-flex"
                      data-track-elem="button" [attr.data-track-name]="translations.backlink" (click)="analyticsClickBackEvent(backLink.targetUri)" allytm-click-tagged="true">
                      <i class="allycon-glyph-chevron-left" aria-hidden="true"></i>
                      <span>{{translations.backlink}}</span>
                    </a>
                  }
                </div>
              }
              <div class="align-self-center text-center">
                <div class="btn-group btn-group-lg" role="group"
                  [attr.aria-label]="translations.sellModule.ariaLabelInventoryNavigation">
                  <a (click)="updateHeader(ManageInventoryHeader.MANAGE_DETAILS)" data-track-elem="tab"
                    data-track-trigger="switch" data-track-name="details" class="inventory-item-nav__link btn btn-primary"
                    routerLink="details" [state]="{ focus: true }" [routerLinkActive]="activeClass"
                  [attr.aria-label]="translations.sellModule.ariaLabelnventoryDetail">{{translations.sellModule.textDetails}}</a>
                  <a (click)="updateHeader(ManageInventoryHeader.MANAGE_OFFERS)" id="inventory_offers_count"
                    data-track-name="offers" data-track-elem="tab" data-track-trigger="switch"
                    class="inventory-item-nav__link btn btn-primary" href="" routerLink="offers" [state]="{ focus: true }"
                    [routerLinkActive]="activeClass"
                    [attr.aria-label]="translations.sellModule.ariaLabelInventoryOffers + auctionItem.openOfferCount">{{translations.sellModule.textOffers}}
                    @if (auctionItem.openOfferCount && auctionItem.openOfferCount !== 0 && auctionItem.auctionItemStatus === 'ACTIVE') {
                      <span
                        >({{
                      auctionItem.openOfferCount }})</span>
                    }
                  </a>
                  <a (click)="updateHeader(ManageInventoryHeader.MANAGE_QUESTIONS)" id="inventory_question_count"
                    data-track-name="questions" data-track-elem="tab" data-track-trigger="switch"
                    class="inventory-item-nav__link btn btn-primary" href="" routerLink="questions"
                    [state]="{ focus: true }" [routerLinkActive]="activeClass"
                    [attr.aria-label]="translations.sellModule.ariaLabelInventoryQuestions + auctionItem.openQuestionCount">{{translations.sellModule.textQuestions}}
                    @if (auctionItem.openQuestionCount && auctionItem.openQuestionCount !== 0 && auctionItem.auctionItemStatus === 'ACTIVE') {
                      <span
                        >({{
                      auctionItem.openQuestionCount }})</span>
                    }
                  </a>
                </div>
              </div>
              <!-- using white class to to hide from view -->
              <div class="d-md-flex d-none white" aria-hidden="true">
              </div>
            </nav>
          }
        </section>
      </div>
    </div>

    @if (showVehicleCard) {
      <section class="container">
        <inventory-item-card></inventory-item-card>
      </section>
    }

    <section class="container">
      <div class="inventory-item-shell__divider"></div>
    </section>

    @if (showErrorBanner) {
      <section class="container">
        <app-sell-banner (close)="closeBanner()" [bannerConfig]="banner"> </app-sell-banner>
      </section>
    }

    <div class="inventory-item-shell__content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
